import type { ReactNode } from 'react'

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

import { EdgeLabelForm } from './edge-label-form.atom'

export interface EdgeLabelPopoverProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  label: string
  onSave: (label: string) => void
  triggerElement: ReactNode
}

export const EdgeLabelPopover = ({
  isOpen,
  onOpenChange,
  label,
  onSave,
  triggerElement,
}: EdgeLabelPopoverProps): ReactNode => {
  const handleSave = (newLabel: string): void => {
    onSave(newLabel)
    onOpenChange(false)
  }

  const handleCancel = (): void => {
    onOpenChange(false)
  }

  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{triggerElement}</PopoverTrigger>
      <PopoverContent className="edge-label-popover w-64 p-3" align="center" side="top">
        <EdgeLabelForm label={label} isOpen={isOpen} onSave={handleSave} onCancel={handleCancel} />
      </PopoverContent>
    </Popover>
  )
}

EdgeLabelPopover.displayName = 'EdgeLabelPopover'
